export default function thaiStyleTransform(input) {
  return input
    .replace(/a/gi, "ค")
    .replace(/b/gi, "๒")
    .replace(/d/gi, "๔")
    .replace(/e/gi, "є")
    .replace(/f/gi, "Ŧ")
    .replace(/h/gi, "ђ")
    .replace(/i/gi, "เ")
    .replace(/j/gi, "ן")
    .replace(/k/gi, "к")
    .replace(/l/gi, "l")
    .replace(/m/gi, "м")
    .replace(/n/gi, "ภ")
    .replace(/o/gi, "๏")
    .replace(/r/gi, "ภ")
    .replace(/s/gi, "ร")
    .replace(/t/gi, "т")
    .replace(/u/gi, "ย")
    .replace(/ /gi, "ㅤ");
}
